import Rails from "@rails/ujs"
import { Turbo } from "@hotwired/turbo-rails"
import '../controllers'

if (!window._rails_loaded) {
  Rails.start()
}

Turbo.session.drive = false

import "@/javascript/components/polyfills"

import "lazysizes/plugins/unveilhooks/ls.unveilhooks"
import "lazysizes/lazysizes"
import "@/javascript/components/tools/lazy_sizes/data_module"
import "@/javascript/components/lazy_svg"
import "@/javascript/components/tools/one_click"

import "@/javascript/components/ajax_forms"
import "@/javascript/components/callback_form"
import "@/javascript/components/datepickers"
import "@/javascript/components/equalizer"
import "@/javascript/components/external_scripts_loader"
import "@/javascript/components/faqs"
import "@/javascript/components/late_prefetch"
import "@/javascript/components/max_words"
import "@/javascript/components/modal"
import "@/javascript/components/selects"
import "@/javascript/components/toggling"
import "@/javascript/components/profile_counters"

import "@/javascript/components/navigation"
import "@/javascript/components/load"
